import { render, staticRenderFns } from "./EmailsGoingOut.vue?vue&type=template&id=5cfd9598&scoped=true"
import script from "./EmailsGoingOut.vue?vue&type=script&lang=js"
export * from "./EmailsGoingOut.vue?vue&type=script&lang=js"
import style0 from "./EmailsGoingOut.vue?vue&type=style&index=0&id=5cfd9598&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfd9598",
  null
  
)

export default component.exports